import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteInfo } from '@/mocks/feed';

const navItems = [
  { label: '首页', to: '/' },
  { label: '瓜田情报库', to: '/feed' },
  { label: '深夜专题', to: '/#topics' },
  { label: '关于我们', to: '/about' },
];

export default function SiteHeader() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.hash]);

  const isHome = location.pathname === '/';
  const transparent = isHome && !scrolled && !menuOpen;
  const isActive = (to: string) => {
    const base = to.split('#')[0];
    if (base === '/') return location.pathname === '/';
    return location.pathname.startsWith(base);
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        transparent
          ? 'border-b border-transparent bg-transparent'
          : 'border-b border-background-200/70 bg-background-50/92 backdrop-blur-md'
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-[1440px] items-center justify-between px-4 md:px-8">
        <Link to="/" className="flex items-center gap-2.5" aria-label={`${siteInfo.name}首页`}>
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-white">
            <i className="ri-moon-clear-fill text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">{siteInfo.name}</span>
            <span className="mt-0.5 hidden text-[10px] tracking-[0.28em] text-foreground-600 uppercase sm:block">
              Night Gossip Desk
            </span>
          </span>
          <span className="ml-1 hidden items-center gap-1.5 rounded-full border border-primary-500/40 bg-primary-500/10 px-2 py-1 md:flex">
            <span className="h-1.5 w-1.5 rounded-full bg-primary-400 animate-pulse-dot" />
            <span className="font-label text-[10px] tracking-widest text-primary-300">LIVE</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`rounded-md px-3.5 py-2 font-label text-sm transition-colors ${
                isActive(item.to)
                  ? 'bg-background-100 text-foreground-950'
                  : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-900'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/#subscribe"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm text-white transition-colors hover:bg-primary-600 md:inline-flex"
          >
            深夜订阅
          </Link>
          <button
            type="button"
            aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-3-line text-xl'} />
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-200/70 bg-background-50/98 backdrop-blur-md md:hidden">
          <nav className="mx-auto flex w-full max-w-[1440px] flex-col px-4 py-3" aria-label="移动端导航">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`rounded-md px-3 py-3 text-sm ${
                  isActive(item.to) ? 'bg-background-100 text-foreground-950' : 'text-foreground-700'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/#subscribe"
              className="mt-2 rounded-md bg-primary-500 px-3 py-3 text-center text-sm text-white"
            >
              深夜订阅
            </Link>
          </nav>
        </div>
      ) : null}
    </header>
  );
}